import { createContext, useContext } from 'react'
import { FlightsClassTypes, type FareClassWithReward } from 'constants/flight'
import noop from 'lib/function/noop'

interface MaldivesDirectBundleContextValue {
  charterBundle: boolean
  isPricePerPerson: boolean
  fareClass: FlightsClassTypes
  /** Full fare class including reward variant (e.g. economy-rewards). */
  selectedFareClass?: FareClassWithReward
  departureAirportCode?: string
  duration?: number
  allowedFareClassesByOfferId: Map<string, Array<FlightsClassTypes>>
  hasFareClassRestrictionsByOfferId: Map<string, boolean>
  /** True when the user has explicitly selected dates (not just the cheapest-date fallback). */
  hasUserSelectedDates: boolean
  /** Uses indicative Classic Rewards pricing instead of live reward availability pricing. */
  useRewardPreviewPricing?: boolean
  canOpenFareClassModal: boolean
  openFareClassModal: () => void
  selectedCabin?: FlightsClassTypes | null
  rewardSeatsOnly?: boolean
  isPromotionPriceApplied?: boolean
}

export const EMPTY_FARE_CLASS_MAP = new Map<string, Array<FlightsClassTypes>>()
export const EMPTY_RESTRICTIONS_MAP = new Map<string, boolean>()

const MaldivesDirectBundleContext = createContext<MaldivesDirectBundleContextValue>({
  charterBundle: false,
  isPricePerPerson: true,
  fareClass: FlightsClassTypes.ECONOMY,
  departureAirportCode: undefined,
  duration: undefined,
  allowedFareClassesByOfferId: EMPTY_FARE_CLASS_MAP,
  hasFareClassRestrictionsByOfferId: EMPTY_RESTRICTIONS_MAP,
  hasUserSelectedDates: false,
  canOpenFareClassModal: false,
  openFareClassModal: noop,
})

export const MaldivesDirectBundleProvider = MaldivesDirectBundleContext.Provider

export function useMaldivesDirectBundleContext(): MaldivesDirectBundleContextValue {
  return useContext(MaldivesDirectBundleContext)
}
